import { isW9SystemId } from './w9Template';

// The promoter's own step-one fields (the payee slot, w9-plan D13) from
// the form's working definition, in form order.
export const payeeFieldsOf = (form) => {
  const definition =
    form && form.working_version && form.working_version.definition;
  const fields = (definition && definition.fields) || [];
  return fields.filter((f) => f && f.id && !isW9SystemId(f.id));
};

export default payeeFieldsOf;
